import { render, staticRenderFns } from "./LiveStageWaypointTable.vue?vue&type=template&id=895a7f84"
import script from "./LiveStageWaypointTable.vue?vue&type=script&lang=js"
export * from "./LiveStageWaypointTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports